module.exports = __webpack_public_path__ + "static/media/house.69fb82e7.png";